import api from './api';

export const loginWithToken = async (firebaseToken) => {
  const response = await api.post('/auth/login', { firebase_token: firebaseToken });
  return response.data;
};

export const signupWithToken = async (firebaseToken, data) => {
  const response = await api.post('/auth/signup', {
    firebase_token: firebaseToken,
    display_name: data.displayName,
    business_name: data.businessName,
  });
  return response.data;
};

export const getMe = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};
